module.exports = __webpack_public_path__ + "static/media/land.c606f7fb.png";